import {createContext, useEffect, useState, useRef} from 'react';
import axios from 'axios';
import { io } from 'socket.io-client';

export const ChatContext = createContext();
export const ChatContextProvider = ({children}) => {
    const baseURL = "https://ew.greenlightautomotivesolutions.com/bridge/twilio/";

    const Axios = axios.create({ baseURL: baseURL });

    const [chatList,setChatList] = useState([]);
    
    const [convoData,setConvoData] = useState([]);

    const [initialLoad,setInitialLoad] = useState(true);

    const socketRef = useRef();

    const [activeChatData, setActiveChatData] = useState([]);

    const activeChatIndex = useRef();

    const getConversations = async () => {

        try {

            const response = await Axios.get('?action=get_convos',{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            setChatList(response.data.data.chat_list || []);

            return response.data.data.convseration_data || {};

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const initiateConvo = async (chat_data) => {
        console.log(chat_data);

        if(chat_data['name']) {
            const convo_sid = await startConversation(chat_data['name']);

            if(convo_sid) {
                await addChatParticipant(convo_sid);

                await Promise.all(chat_data.participants.map(async (v,i) => {
                    if(v.phone) addSMSParticipant(convo_sid,v.phone)
                }));
            }
        }

        listAllMessages();
    }

    const startConversation = async (name) => {

        const values = {name:name};

        try {

            const response = await Axios.post('?action=start_convo',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data.data.convo_sid || null;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const addSMSParticipant = async (convo_sid,phone) => {

        const values = {convo_sid:convo_sid,phone:phone};

        try {

            const response = await Axios.post('?action=add_sms_participant',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const addChatParticipant = async (convo_sid) => {

        const values = {convo_sid:convo_sid,chat_user:"Experience Wholesale Site"};

        try {

            const response = await Axios.post('?action=add_chat_participant',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const listMessages = async (convo_sid,chat_service_sid) => {

        const values = {convo_sid:convo_sid,chat_service_sid:chat_service_sid};

        try {

            const response = await Axios.post('?action=list_messages',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            var convo_data = response.data.data.messages || [];

            console.log(convo_data);

            var now = new Date();
            var today = new Date()
            today.setHours(0,0,0,0);

            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1); // Set to yesterday
            yesterday.setHours(0, 0, 0, 0); // Set time to midnight

            convo_data.map((v,i) => {

                v['date_object'] = new Date(v['date']['date'] + "Z");
                v['message_time'] = v['date_object'].toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'});

                v['timeDiff'] = now.getTime() - v['date_object'].getTime();
                v['diffHours'] = Math.floor(v['timeDiff'] / (1000 * 3600)); 

                v['relative_day'] = v['date_object'].getTime() > today.getTime() ? "Today" : (v['date_object'].getTime() > yesterday.getTime() ? "Yesterday" : (v['date_object'].getMonth() + 1) + "/" + v['date_object'].getDate());
                v['relative_time'] = chatTimeSince(now,v['date_object']);   

                convo_data[i] = v;

            });

            console.log(convo_data);

            return convo_data;

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const listParticipants = async (convo_sid) => {

        const values = {convo_sid:convo_sid};

        try {

            const response = await Axios.post('?action=list_participants',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            return response.data.data.participants || [];

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const sendMessage = async (convo_sid,chat_service_sid,message,attachments=null) => {

        var values = {convo_sid:convo_sid,message:message};

        if(attachments) values.attachments = attachments;

        console.log(values);

        try {

            const response = await Axios.post('?action=send_message',values,{
                retry: 0, retryDelay: 3000
            });

            console.log(response.data);

            updateConversationMessages(convo_sid,chat_service_sid);

        } catch (error) {
            console.error('Error fetching vehicles:', error);
            return {}; // Or handle error as needed
        }
    };

    const updateConversationMessages = async (convo_sid,chat_service_sid) => {
        var messages = await listMessages(convo_sid,chat_service_sid);

        var newConvoData = convoData.map((v,i) => {
            if(v.convo_sid = convo_sid) {
                v['current_messages'] = messages;
            } 

            return v;
        });

        console.log(newConvoData);

        setConvoData(newConvoData);

    }

    const listAllMessages = async () => {
        var convo_data = await getConversations();

        if(initialLoad) {
            setConvoData(convo_data);
            setInitialLoad(false);
        }

        const promises = convo_data.map(async (v,i) => {
            console.log(v);

            convo_data[i]['current_messages'] = await listMessages(v.convo_sid,v.chat_service_sid);

            convo_data[i]['current_participants'] = await listParticipants(v.convo_sid);
        });

        const results = await Promise.all(promises);

        console.log("new convo data",convo_data,activeChatIndex.current,convo_data[activeChatIndex.current]);

        setConvoData(convo_data);

        setActiveChatData(convo_data[activeChatIndex.current]);
    }    

    const uploadDocument = async (values) => {

        console.log(values);

        const {data} = await Axios.post('twilio_upload_file.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
            console.log(error_data);
        });

        console.log(data);

        return data;
    }

    const removeBackground = async (values) => {

        console.log(values);

        const {data} = await Axios.post('remove_background.php',values).catch(function (error) {
            if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
            else if (error.request) console.log(error.request);
            else console.log('Error', error.message);
            console.log(error.config);
            var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
            //email_axios_error(error_data);
            console.log(error_data);
        });

        console.log(data);

        return data;
    }

    const getDocumentInfo = async (key) => {

        var file_info = [];

        if(key.includes('https://api.twilio.com')) {

            file_info[key] = {'metadata':{'content-type':'image'},'url':key};

        } else {

            var values = {
                'key':key
            };

            console.log(values);

            const {data} = await Axios.post('sms/s3_file_info.php',values).catch(function (error) {
                if (error.response) console.log(error.response.data, error.response.status, error.response.headers);
                else if (error.request) console.log(error.request);
                else console.log('Error', error.message);
                console.log(error.config);
                var error_data = {"error" : error, "url" : error.request && error.request.url ? error.request.url : "none provided"};
                //email_axios_error(error_data);
            });
            
            file_info[key] = data;

        }

        //setChatAttachmentInfo((prev) => Object.assign({}, prev, file_info));
    }

    const chatTimeSince = (now,date) => {

		var seconds = Math.floor((now - date) / 1000);
        
        if(seconds < 0) seconds = 0;

		var interval = Math.floor(seconds / 31536000);

		if (interval > 1) {
			return interval + " years";
		}
		interval = Math.floor(seconds / 2592000);
		if (interval > 1) {
			return interval + " months";
		}
		interval = Math.floor(seconds / 86400);
		if (interval > 1) {
			return interval + " days";
		}
		interval = Math.floor(seconds / 3600);
		if (interval > 1) {
			return interval + " hours";
		}
		interval = Math.floor(seconds / 60);
		if (interval > 1) {
			return interval + " minutes";
		}
		return Math.floor(seconds) + " seconds";
	}

    const openChat = (chat_index) => {
        activeChatIndex.current = chat_index;
        console.log('Opening chat :', chat_index,convoData[chat_index]);
        setActiveChatData(convoData[chat_index]);
    };

    useEffect(() => {

        return;

        if(!socketRef.current) {
            console.log("setting socket ref");
            socketRef.current = io("https://ew.greenlightautomotivesolutions.com:9000", {
                transports: ['websocket']
            });
        }

        if(socketRef.current) {
            
            socketRef.current.on('message', handleMessage);

            //console.log("set handlemessage");
        
            return () => {
                socketRef.current.off('message', handleMessage);
            };
        }

        function handleMessage(message){
            console.log("socket received message",message);

            listAllMessages();
        }
    }, []);

    /*useEffect(() => {

        function connectFunction() {
            console.log("connected",socketRef.current);
            
        }

        if(socketRef.current) {

            console.log("setting socket events");

            socketRef.current.on('error', function() {
                console.log("Sorry, there seems to be an issue with the connection!");
            });
        
            socketRef.current.on('connect_error', function(err) {
                console.log("connect failed ",err);
            });
        
            socketRef.current.on('connect', connectFunction);

            //socketRef.current.on('connection', connectFunction);
    
            return () => {
              socketRef.current.off('connect', connectFunction);
            };
        }
    }, []);*/

    return (
        <>
            <ChatContext.Provider value={{listAllMessages,convoData,chatList,initiateConvo,uploadDocument,removeBackground,sendMessage,activeChatData,openChat}}>
                {children}
            </ChatContext.Provider>
        </>
    );
}

export default ChatContextProvider